<template>
    <div>
        <v-container  v-if="!creatingNew">
            <div class="pa-4">
                <v-alert class="alerts" dense text outlined
                    :color="($vuetify.theme.dark) ? 'var(--errorDark)' : 'var(--errorLight)'" icon="mdi-card-account-details">
                    You can select or add bank account details here to receive payments. Select "Add New" to enter new bank account details or select 
                    bank account details you've previously entered.<br/>
                    <b>If you have added incorrect or invalid payment details you can recitfy this by deleting the incorrect details and adding 
                        the new, corrected details here.
                        </b>
                </v-alert>

                <v-btn dense block @click="creatingNew = !creatingNew"
                    :color="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'">
                    <v-icon class="mr-2">mdi-plus-box</v-icon>
                    Add New
                </v-btn>

                <v-card v-for="(pd, index) in paymentDetails" class="mt-4 pa-4" :key="index">
                     
                        <b>Bank Account Name</b> {{ pd.accountName }} <br/>
                    <b>Account Number</b> {{ pd.accountNumber }} <br/>
                    <b>Sort Code</b> {{ pd.sortcode }}<br/>
                    <b>IBAN</b> {{ pd.iban }}<br/>

                    <div class="mt-2">
                    <v-btn class="mr-2" dense @click="selectBankAccountDetails(pd)"
                                :color="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'">
                        <v-icon class="mr-2">mdi-check-circle</v-icon>
                        SELECT
                    </v-btn>
      
                    <v-btn dense @click="deletePaymentDetails(pd.id)"
                        :color="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'">
                            <v-icon class="mr-2">mdi-delete</v-icon>
                        DELETE
                    </v-btn>
                    </div>

                </v-card>




            </div>




        </v-container>
        <v-container class="pa-4" v-if="!currencyChosen && creatingNew">
            <v-btn dense block @click="creatingNew = !creatingNew"
                :color="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'">
                <v-icon class="mr-2">mdi-arrow-left</v-icon>
                Select Existing
            </v-btn>

            <v-card class="mt-4">
                <v-card-subtitle class="text-h6">Select the currency of the bank account you wish to add
                </v-card-subtitle>
                <v-card-text>
                    <v-alert class="alerts" dense text outlined
                        :color="($vuetify.theme.dark) ? 'var(--errorDark)' : 'var(--errorLight)'"
                        icon="mdi-swap-horizontal">
                        {{ euroMessage }}
                    </v-alert>
                </v-card-text>
                <v-card-text>
                    <!-- Select the Currency -->
                    <div v-if="this.accountSettings != null">
                        <v-radio-group v-model="currency" row required>
                            <v-radio v-for="(curr, index) in accountSettings.currencies" :key="index" :label="curr"
                                :value="curr" :color="($vuetify.theme.dark) ? 'var(--darkColor)' : 'var(--lightColor)'">
                            </v-radio>
                        </v-radio-group>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn v-if="currency != ''" :color="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'"
                        class="float-right" block v-on:click="currencyChosen = true;">Next</v-btn>
                </v-card-actions>
            </v-card>

        </v-container>

        <v-container v-if="!showConfirmation && currencyChosen">
            <v-row>
                <v-col>
                    <v-btn :color="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'"
                        v-on:click="currency = ''; currencyChosen = false;">Back to currency</v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <h2 style="padding-left:2px;">Update Account details</h2>
                </v-col>
            </v-row>
            <v-row>
                <v-col v-if="spinner" align="center">
                    <v-progress-circular :color="($vuetify.theme.dark) ? 'var(--darkColor)' : 'var(--lightColor)'"
                        size="120" indeterminate></v-progress-circular>
                </v-col>
                <v-col v-if="!spinner">
                    <v-card>
                        <v-alert class="alerts" dense text outlined
                            :color="($vuetify.theme.dark) ? 'var(--errorDark)' : 'var(--errorLight)'"
                            icon="mdi-account-lock">
                            You are soley responsible for entering the information bellow correctly. Failure to do so
                            will result in bank transfers to an incorrect bank account and will not be refunded.
                        </v-alert>
                        <v-form ref="formbank" class="mx-2" lazy-validation>
                            <v-card-text>
                                <span style="display: inline; font-size: large;">
                                    <b style="display: inline-block">Account Number:</b>&nbsp; <p
                                        style="display: inline-block">
                                        {{ safeAccountDetails.accountNumber }}</p>
                                </span>
                                <br>
                                <span style="display: inline; font-size: large;">
                                    <b style="display: inline-block">Sort Code:</b>&nbsp; <p
                                        style="display: inline-block">
                                        {{ safeAccountDetails.sortcode }}</p>
                                </span>
                                <br>
                                <span style="display: inline; font-size: large;">
                                    <b style="display: inline-block">IBAN:</b>&nbsp; <p style="display: inline-block">
                                        {{ safeAccountDetails.iban }}</p>
                                </span>

                                <v-divider style="margin-top: 20px; margin-bottom: 20px;"></v-divider>

                                <!-- AccountDetails Spinner -->
                                <div v-if="accDetailsSpinner" align="center">
                                    <v-progress-circular
                                        :color="($vuetify.theme.dark) ? 'var(--darkColor)' : 'var(--lightColor)'"
                                        size="120" indeterminate></v-progress-circular>
                                </div>
                                <div v-if="!accDetailsSpinner">

                                    <v-text-field v-model="accountName" v-on:keyup.enter="onEnter"
                                        
                                        label="Bank Account Name (This must match the name on your account )" required>
                                    </v-text-field>

                                    <!-- Account Number -->
                                    <v-text-field v-model="accountNumber" v-on:keyup.enter="onEnter"
                                        v-if="currency == 'GBP'" :rules="[v => !!v || 'New Account number is required']"
                                        label="New Account Number" required>
                                    </v-text-field>
                                    <!-- Sort Code -->
                                    <v-text-field v-model="sortCode" v-on:keyup.enter="onEnter" v-if="currency == 'GBP'"
                                        :rules="[v => !!v || 'New sortCode is required']" label="New Sort Code"
                                        required>
                                    </v-text-field>
                                    <!--IBAN-->
                                    <v-text-field v-model="iban" v-on:keyup.enter="onEnter" v-if="currency != 'GBP'"
                                        :rules="[v => !!v || 'Iban is required for European bank account']" label="IBAN"
                                        required>
                                    </v-text-field>

                                    <v-divider class="pa-2"></v-divider>
                                    <!-- DOB -->
                                    <BirthDayPickerDialog :defaultDate="dob" @saveDob="saveDob"></BirthDayPickerDialog>
                                    <!-- First Name -->
                                    <v-text-field v-model="firstname" v-on:keyup.enter="onEnter"
                                        :rules="[v => !!v || 'First name is required']" label="First Name" required>
                                    </v-text-field>
                                    <!-- Surname -->
                                    <v-text-field v-model="secondname" v-on:keyup.enter="onEnter"
                                        :rules="[v => !!v || 'Surname is required']" label="Surname" required>
                                    </v-text-field>
                                    <!-- Email -->
                                    <v-text-field v-model="email" v-on:keyup.enter="onEnter"
                                        :rules="[v => !!v || 'Email is required']" label="Email" disabled>
                                    </v-text-field>
                                    <!-- Country -->
                                    <v-select filled dense label="Country:" v-model="country"
                                        :items="COUNTRY_ADDRESS_POSTALS" item-text="name" @input="postcodeRegexChange">
                                    </v-select>
                                    <!-- Address 1-->
                                    <v-text-field v-model="address1" v-on:keyup.enter="onEnter"
                                        :rules="invalidCharRules" label="Address 1" required>
                                    </v-text-field>
                                    <!-- Address 2-->
                                    <v-text-field v-model="address2" v-on:keyup.enter="onEnter" label="Address 2"
                                    :rules="invalidCharRules">
                                    </v-text-field>
                                    <!-- City-->
                                    <v-text-field v-model="townCity" v-on:keyup.enter="onEnter"
                                        label="City"
                                        :rules="invalidCharRules">
                                    </v-text-field>
                                    <!-- Region-->
                                    <v-text-field v-model="region" v-on:keyup.enter="onEnter"
                                        :rules="[v => !!v || 'Region is required']" label="Region">
                                    </v-text-field>
                                    <!-- Postcode -->
                                    <v-text-field v-model="postcode" v-on:keyup.enter="onEnter" :rules="postcodeRules"
                                        label="Postcode">
                                    </v-text-field>
                                </div>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <div align="center">
                                    <v-btn v-if="safeAccountDetails.accountNumber == 'None'"
                                        v-on:click="validateForm"
                                        :color="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'">Create
                                        account details
                                    </v-btn>
                                    <v-btn v-if="safeAccountDetails.accountNumber != 'None'"
                                        v-on:click="validateForm"
                                        :color="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'">Change
                                        account details
                                    </v-btn>
                                </div>
                            </v-card-actions>
                        </v-form>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <v-col v-if="updatingSpinner" align="center">
            <v-progress-circular :color="($vuetify.theme.dark) ? 'var(--darkColor)' : 'var(--lightColor)'" size="120"
                indeterminate></v-progress-circular>
        </v-col>
        <v-container v-if="showConfirmation && currencyChosen && !updatingSpinner">
            <v-card>
                <v-card-title>Confirm account details</v-card-title>
                <v-card-subtitle class="text-h6">Account Details</v-card-subtitle>
                <v-card-text>
                    <ul>
                        <li>Account number: {{ accountNumber }}</li>
                        <li>Sort code: {{ sortCode }}<br></li>
                        <li v-if="currency != 'GBP'">IBAN: {{ iban }}</li>
                        <li>Currency selected: {{ currency }}</li>
                    </ul>
                </v-card-text>

                <v-card-subtitle class="text-h6">Important Information</v-card-subtitle>
                <v-card-text>
                    {{ tAndC }}
                </v-card-text>
                <v-card-subtitle v-if="currency != 'GBP'" class="text-h6">European exchange rates</v-card-subtitle>
                <v-card-text v-if="currency != 'GBP'">
                    {{ euroMessage }}
                </v-card-text>

                <v-card-text>
                    <v-checkbox v-model="acceptTerms" label="I have read the Important Information section" value=true>
                    </v-checkbox>
                    <v-checkbox v-if="currency != 'GBP'" v-model="acceptEurofx"
                        label="Accept you understand using a European bank account can incur fees" value=true>
                    </v-checkbox>
                </v-card-text>

                <v-card-actions>
                    <v-btn v-on:click="showConfirmation = false"
                        :color="($vuetify.theme.dark) ? 'errorDark' : 'errorLight'" class="float-left">Back
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn v-if="safeAccountDetails.accountNumber == 'None' && acceptTerms && acceptEurofx"
                        v-on:click="updateBankAccountDetails"
                        :color="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'" class="float-right">Confirm
                        and create
                    </v-btn>
                    <v-btn v-if="safeAccountDetails.accountNumber != 'None' && acceptTerms && acceptEurofx"
                        v-on:click="updateBankAccountDetails"
                        :color="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'" class="float-right">Confirm
                        and update
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-container>
    </div>
</template>

<script>
import RestResource from '../RestResource.js';
import { mapActions, mapGetters } from 'vuex';
import accessHelper from '@/mixins/accessHelper.js';
import postcodeHelper from '@/mixins/postcodeHelper.js'
import moment from 'moment';

import BirthDayPickerDialog from '../components/BirthDayPickerDialog.vue'
const restResourceService = new RestResource();
export default {
    name: "ChangeAccountDetailsPage",
    setup() {

    },
    mixins: [accessHelper, postcodeHelper],
    props: {

    },
    components: {
        BirthDayPickerDialog,
    },
    data: () => ({
        spinner: false,
        updatingSpinner: false,
        accDetailsSpinner: false,
        paymentDetails: null,
        safeAccountDetails: { account: { account_number: 'None', sort_code: 'None', iban: 'None' } },
        accountNumber: "",
        accountName: "",
        creatingNew: false,
        sortCode: "",
        iban: "",
        cAccountNumber: "",
        cSortCode: "",
        currency: "",
        dob: "",
        firstname: "",
        secondname: "",
        email: "",
        address1: "",
        address2: "",
        townCity: "",
        region: "",
        country: "",
        postcode: "",
        postcodeRegex: "",
        postcodeRules: [],
        invalidCharRules: [],
        accountDetails: -1,
        showConfirmation: false,
        tAndC: process.env.VUE_APP_TandC,
        euroMessage: process.env.VUE_APP_euro_fx_message,
        acceptTerms: false,
        acceptEurofx: false,
        currencyChosen: false,
    }),
    mounted: function () {
        this.getBankDetails();
        this.getAccountDetails();
    },
    watch: {
        postcode() {
            this.postcodeRules = [];
        },
        address1(){
            this.invalidCharRules = [];
        },
        address2(){
            this.invalidCharRules = [];
        },
        townCity(){
            this.invalidCharRules = [];
        }
    },
    computed: {
        isCurrencySelection() {
            if (this.accountSettings.currencies)
                return true;
            else return false;
        },
        ...mapGetters(['accountSettings'])
    },
    methods: {
        ...mapActions([
            'fetchAccount',
            'fetchAccountBalance'
        ]),
        onEnter: function () {
            this.ChangeBankDetails();
        },
        postcodeRegexChange() {
            this.COUNTRY_ADDRESS_POSTALS.forEach(el => {
                if (el.name == this.country) {
                    return this.postcodeRegex = el.postal;
                }
            })
        },

        async deletePaymentDetails(pd) {


            this.updatingSpinner = true;
            await restResourceService.deletePaymentDetails(pd);
            this.paymentDetails = await restResourceService.getAllPaymentDetails();
            this.updatingSpinner = false;

            this.fetchAccount();
            this.$emit('snack', 'Payment Details Deleted');
        },
        async getAccountDetails() {
            this.accDetailsSpinner = true;
            this.accountDetails = await restResourceService.getAccountAddress();
            
            this.accDetailsSpinner = false;

            //fill in details if found
            if (this.accountDetails == -1) return;

            this.dob = moment(this.getAccount.dob).format("YYYY-MM-DD");
            this.nameOnCard = this.getAccount.firstname + " " + this.getAccount.lastname;
            this.address1 = this.accountDetails.address1;
            this.address2 = this.accountDetails.address2;
            this.townCity = this.accountDetails.townCity;
            this.region = this.accountDetails.region;
            this.postcode = this.accountDetails.postcode;
            this.country = this.accountDetails.country;
            this.postcodeRegexChange();
            this.firstname = this.getAccount.lastname;
            this.secondname = this.getAccount.firstname;
            this.email = this.getAccount.email;
            
            this.paymentDetails = await restResourceService.getAllPaymentDetails();

        },
        validateForm() {
            this.acceptEurofx = false;
            this.acceptTerms = false;
            if (this.postcodeRegex)
                this.postcodeRules = this.postcodeRegex;       
            this.invalidCharRules = [v => /^(?!.*[^a-zA-Z0-9 -])/.test(v) || 'Special Characters are not valid'];
            
            if (this.accountName.length < 4 )
                return this.$emit('snack', "You must provude the name on your bank account")
            if (this.accountNumber.length != 8 && this.currency == 'GBP')
                return this.$emit('snack', "Account number must be 8 digits")
            if (this.sortCode.length != 6 && this.currency == 'GBP')
                return this.$emit('snack', "Sort code must be 6 digits");
            if (!this.onlyNumbers(this.accountNumber) && this.currency == 'GBP')
                return this.$emit('snack', "Account number must be a valid number")
            if (!this.onlyNumbers(this.sortCode) && this.currency == 'GBP')
                return this.$emit('snack', "Sort code must be a valid number");
            if (this.currency != 'GBP' && (this.iban.replace(/\s/g, '').length < 15 || this.iban.replace(/\s/g, '').length > 34))
                return this.$emit('snack', "Iban must have a length between 15 and 34 characters");
            if (this.currency == '')
                return this.$emit('snack', "Must select a currency");

            //Customate validation
            if (this.address1.length > 34)
                return this.$emit('snack', "Address 1 field must be less than 35 characters")
            if (this.address2.length > 34)
                return this.$emit('snack', "Address 2 field must be less than 35 characters")
            if (this.townCity.length > 34)
                return this.$emit('snack', "City field must be less than 35 characters")
            
                //a-zA-Z0-9/-?:.+\
            if (this.address1.length > 34)
                return this.$emit('snack', "Address 1 field must be less than 35 characters")
            if (this.address2.length > 34)
                return this.$emit('snack', "Address 2 field must be less than 35 characters")
            if (this.townCity.length > 34)
                return this.$emit('snack', "City field must be less than 35 characters")
            //There doesn't seem to be any validation on the region

            //GBP need acc and sortcode, EURO need iban
            if (this.currency == 'GBP') {
                this.acceptEurofx = true;
                this.iban = "";
            } else {
                this.accountNumber = "";
                this.sortCode = "";
            }


            if (this.address1.includes(',') || this.address2.includes(',') || this.townCity.includes(',') || this.region.includes(',')) {
                return this.$emit('snack', "No commas allowed in address fields");
            }

            //Wait for rules to complete then check if they have been broken. 
            let self = this;
            setTimeout(function () {
                if (self.$refs.formbank.validate())
                    self.showConfirmationScreen();
                else
                    return self.$emit('snack', 'Invalid Inputs');
            })

        },
        showConfirmationScreen() {
            this.showConfirmation = true;
        },
        async selectBankAccountDetails(pd) {

            this.updatingSpinner = true;
            await restResourceService.updatePaymentDetails(pd);
            this.updatingSpinner = false;

            this.fetchAccount();
            this.$emit('snack', 'Payment Details Updated');
            this.$router.push({ path: '/MyAccount' })
          

        },
        async updateBankAccountDetails() {
            //After validate show the confirmation screen.
            //If dismiss then don't continue
            this.updatingSpinner = true;
            const pd = {
                'accountNumber': this.accountNumber,
                'accountName' : this.accountName,
                'sortCode': this.sortCode,
                'iban': this.iban.replace(/\s/g, ''),
                'first_name': this.firstname,
                'last_name': this.secondname,
                'birth_date': this.dob,
                'email': this.email,
                address: {
                    'address_line_1': this.address1,
                    'address_line_2': this.address2,
                    'postcode': this.postcode,
                    'city': this.townCity,
                    'locality': this.region,
                    'country': this.country,
                },
                'currency': this.currency, //displayed if setting allows. defaults to "£",
            }
            const status = await restResourceService.postUpdateBankDetails(pd);
            this.updatingSpinner = false;
            console.log(status)
            if (status != 200)
                return;

            this.fetchAccount();
            this.$router.push({ path: '/MyAccount' })
            this.$emit('snack', 'Payment Details Accepted');
        },

        async getBankDetails() {
            this.spinner = true;
            this.safeAccountDetails = await restResourceService.getBankDetails();
            this.spinner = false;
        },

        saveDob(date) {
            this.dob = date;
        },
        onlyNumbers(str) {
            return /^[0-9]+$/.test(str);
        }
    },
}
</script>

<style scoped>

</style>